import React, {useState} from 'react';
import {Calendar} from '../../icons/calendar';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {AppTerms} from "../../app/app-terms";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {DatePickerProps} from "../date-picker/date-picker";
import {Button, ButtonComponentProps} from "../misc/buttons/button";
import {Tooltip} from "../tooltip/tooltip";
import {DatePickerTooltip} from "../date-picker/date-picker.tooltip";

export class HeaderDateSelectorPickerDialogProps extends BaseProps {
  i18n: AppTerms;
  onOpen: Function;
  onClose: Function;
  onChange: Function;
  linkType: BaseLinkModel;
  selectedDate: String;
}

export const HeaderDateSelectorPickerDialog = (props: HeaderDateSelectorPickerDialogProps) => {
  const [open, setOpen] = useState(false);

  const dialogProps: DatePickerProps = {
    ...props,
    open: open,
    onClose: (e) => {
      setOpen(false);
      props.onClose && props.onClose();
    },
    onChange: (e) => {
      setOpen(false);
      props.onChange && props.onChange(e);
    },
    onDateChange: props.onDateChange,
  }

  const calenderContainerProps: ButtonComponentProps = {
    className: 'header-date-selector-calender-button-container',
    id: 'calender-button-desktop',
    onClick: () => {
      setOpen(true);
      props.onOpen && props.onOpen();
    }
  }

  return (
    <DatePickerTooltip {...dialogProps}>
      <Tooltip title={props.controller.state.terms.DATER_CALENDAR}>
        <Button {...calenderContainerProps}>
          <Calendar/>
        </Button>
      </Tooltip>
    </DatePickerTooltip>
  );
}
